import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { StockOrderProductModel } from "features/stock-ordering/core/domain/stock-order-product.model";
import { OrderedProductsEdit } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockOrderedEditProductResponse,
  stockOrderedEditProductRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockOrderedEditProductState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockOrderedEditProductState;
  message: string;
}

const initialState: InitialState = {
  status: StockOrderedEditProductState.initial,
  message: "",
};

export const stockOrderedEditProduct = createAsyncThunk(
  "stockOrderedEditProduct",
  async (param: OrderedProductsEdit, { rejectWithValue }) => {
    try {
      const response: stockOrderedEditProductResponse =
        await stockOrderedEditProductRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockOrderedEditProductSlice = createSlice({
  name: "stockOrderedEditProduct",
  initialState,
  reducers: {
    resetstockOrderedEditProductStatus: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockOrderedEditProduct.pending, (state) => {
        state.status = StockOrderedEditProductState.inProgress;
      })
      .addCase(stockOrderedEditProduct.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = StockOrderedEditProductState.success;
          state.message = message;
        }
      })
      .addCase(stockOrderedEditProduct.rejected, (state, action) => {
        state.status = StockOrderedEditProductState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectStockOrderedEditProduct = (state: RootState) =>
  state.stockOrderedEditProduct;

export const { resetstockOrderedEditProductStatus } =
  stockOrderedEditProductSlice.actions;
export default stockOrderedEditProductSlice.reducer;
